export const lowercase = value => value.toLowerCase();
